import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

export default function useLink() {
  const { locale } = useI18n();
  let theme = 'light';
  if (localStorage.getItem('theme')) {
    theme = localStorage.getItem('theme');
  }
  const queryStr = `?locale=${locale.value}&theme=${theme}`;

  const transitUrl = computed(() => {
    if (process.env.VUE_APP_ENV === 'dev') {
      return `https://test-tp.tokenpocket.pro/transit-finance/${queryStr}`;
    } else {
      return `https://transit.finance/${queryStr}`;
    }
  });
  const swapUrl = computed(() => {
    if (process.env.VUE_APP_ENV === 'dev') {
      return `https://test-tp.tokenpocket.pro/dev/${queryStr}`;
    } else {
      return `https://swap.transit.finance/${queryStr}`;
    }
  });

  const swapMarketUrl = computed(() => {
    if (process.env.VUE_APP_ENV === 'dev') {
      return `https://test-tp.tokenpocket.pro/dev/${queryStr}#/market`;
    } else {
      return `https://swap.transit.finance/${queryStr}#/market`;
    }
  });

  const transitDaoUrl = computed(() => {
    return `https://transit.finance/${queryStr}#/stake`;
  });
  
  const transitDonationUrl = computed(() => {
    return `https://transit.finance/${queryStr}#/donation`;
  });

  const transitFeeUrl = computed(() => {
    return `https://transit.finance/${queryStr}#/fee`;
  });

  return { transitUrl, swapUrl, swapMarketUrl, transitDaoUrl, transitDonationUrl, transitFeeUrl };
}
